/*
 * Copyright 2023
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Last modified: 2023.9.13 at 13:20
 */

export default () => {
    let body;
    let menuItems;
    let navContent;
    let menuButton;
    let menuButtonAlt;
    let menuButtonSticky;
    let closeButton;
    let accessibilityMenu;
    let accessibilityMenuToggle;

    const init = () => {
        body = document.querySelector('body');
        menuItems = document.querySelectorAll('.menu-item');

        navContent = document.getElementById('main-menu');
        menuButton = document.getElementById('wp-perf__nav-toggle');
        menuButtonAlt = document.getElementById('wp-perf__nav-toggle__alt');
        closeButton = document.getElementById('wp-perf__nav-toggle-close');
        menuButtonSticky = document.getElementById('wp-perf__nav-toggle--sticky');
        accessibilityMenu = document.querySelector('.wp-block-wp-perf-accessibility-menu-wrapper-mobile');
        accessibilityMenuToggle = document.querySelector('.wp-block-wp-perf-accessibility-menu-wrapper-mobile .js-menu-toggle');



        applyListeners();
    };

    const handleMenuClick = () => {
        toggleClass(body, 'wp-perf__nav--active');
        if(accessibilityMenu) {
            accessibilityMenu.classList.toggle('hidden');
        }
    }; 

    const applyListeners = () => {
        document.addEventListener('scroll', function () {
            if (window.scrollY > 50) {
                if (!body.classList.contains('scrolling')) {
                    body.classList.add('scrolling');
                }
            } else {
                body.classList.remove('scrolling');
            }
        });

        if (accessibilityMenuToggle) {
            accessibilityMenuToggle.addEventListener('click', (e) => {
                e.preventDefault();
                accessibilityMenu.classList.toggle('open');
            });
        }


        if (menuButton) {
            menuButton.addEventListener('click', handleMenuClick);
        }
        if (menuButtonAlt) {
            menuButtonAlt.addEventListener('click', () => {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'instant',
                });
                handleMenuClick();
            });
        }
        if (menuButtonSticky) {
            menuButtonSticky.addEventListener('click', handleMenuClick);
        }

        if (menuItems) {
            menuItems.forEach(function (item) {
                item.addEventListener('click', (event) => {
                    // if a href is an anchor, close the menu after click.
                    if (event.target.href && event.target.href.includes('#')) {
                        if (closeButton) {
                            closeButton.click();
                        } else if (menuButton) {
                            menuButton.click();
                        }
                    }
                });
            });
        }
        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                toggleClass(body, 'wp-perf__nav--active');
            }
        });
    };

    const toggleClass = (element, stringClass) => {
        if (element.classList.contains(stringClass)) {
            element.classList.remove(stringClass);
        } else {
            element.classList.add(stringClass);
        }
    };

    init();
};
